import { useRouter } from 'next/router';
import { useMemo } from 'react';
import useSWR from 'swr';

import { fetcher } from '@/plugins/graphql';
import type { AdminSchool } from '@/types/AdminSchool';

const useAdminSchool = () => {
  const router = useRouter();

  const query = `
    query AdminSchool {
      admin_school {
        slug
        schema
        id
        db
        tenant_id
        is_school_contract
        is_tournament_contract
        is_rental_contract
      }
    }
  `;

  const { data, error } = useSWR(query, fetcher, {
    revalidateOnFocus: false,
  });

  const school: AdminSchool | null = useMemo(() => {
    return (
      data?.admin_school.find((schoolData: AdminSchool) => {
        return schoolData.slug === router.query.schoolSlug;
      }) || undefined
    );
  }, [data, router.query.schoolSlug]);

  return {
    data,
    error,
    school,
  };
};

export default useAdminSchool;
